import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { type SbSharedRecentSalesOverview_creatorRootTransactions$key } from './__generated__/SbSharedRecentSalesOverview_creatorRootTransactions.graphql.ts';

import { FormattedNumber } from 'dibs-react-intl';
import {
    recentSalesAveragePriceDetails,
    recentSalesPriceRangeDetails,
    recentSalesPriceRangeInfo,
} from '../SbSharedRecentSalesMessages/SbSharedRecentSalesMessages.tsx';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './SbSharedRecentSalesOverview.scss';

type Props = {
    creatorRootTransactions:
        | SbSharedRecentSalesOverview_creatorRootTransactions$key
        | null
        | undefined;
    currency: string;
};

export const SbSharedRecentSalesOverview: FC<Props> = ({
    creatorRootTransactions: CreatorRootTransactionsRef,
    currency,
}) => {
    const creatorRootTransactions = useFragment(
        graphql`
            fragment SbSharedRecentSalesOverview_creatorRootTransactions on CreatorRootTransactions {
                minPrice
                maxPrice
                averageSoldPrice
            }
        `,
        CreatorRootTransactionsRef
    );

    const { averageSoldPrice, minPrice, maxPrice } = creatorRootTransactions || {};

    return (
        <table className={classnames(styles.overviewTable, dibsCss.pySmall)}>
            <tbody>
                {averageSoldPrice && (
                    <>
                        <tr className={dibsCss.sassyFontBodySizeLargeTypeHeavy}>
                            <td>
                                <FormattedNumber
                                    value={averageSoldPrice}
                                    style="currency"
                                    currency={currency}
                                    maximumFractionDigits={0}
                                    minimumFractionDigits={0}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className={dibsCss.pbMedium}>
                                    {recentSalesAveragePriceDetails}
                                </div>
                            </td>
                        </tr>
                    </>
                )}
                {minPrice && maxPrice && (
                    <>
                        <tr className={dibsCss.sassyFontBodySizeLargeTypeHeavy}>
                            <td>
                                {recentSalesPriceRangeInfo({
                                    minPrice,
                                    maxPrice,
                                    currency,
                                })}
                            </td>
                        </tr>
                        <tr>
                            <td>{recentSalesPriceRangeDetails}</td>
                        </tr>
                    </>
                )}
            </tbody>
        </table>
    );
};
